import {domReady} from './Functions/DomReady';
import {initLanguageNav, initMainNavigationHandler, initSearchHeader} from './Functions/MainNavigationHandler';
import {mailDecryption} from './Functions/MailDecryption';
import {initSliderFilterContent} from './Functions/Slider/SwiperFilterContent';
import {initPageTeaserSlider, initSlider, initSwiperGallery, initSwiperTimeline} from './Functions/Slider/Swiper';
import {initSliderFilter} from './Functions/Slider/SwiperFilter';
import {newsletterFooter} from './Functions/NewsletterFooter';
import {quicklinkFilter} from './Functions/Quickfilter';
import {landingpageSwitch} from './Functions/LandingPageSwitch';
import {initDocumentShop} from './DocumentShop/DocumentShop';
import {initAlerts} from './Functions/Alert';
import {initAccordionPrintHandler} from './Functions/AccordionPrintHandler';
import {initProjectButton} from './Functions/Project';
import {CalendarList} from './Calendar/CalendarList';
import {wiss_hideHelp, wiss_showHelp, wiss_showMap} from './Functions/SvgMap';
import {initBannerController} from './Functions/DesignAwardBanner';
import {MapDropdowns} from './Functions/PublicTransportMap';
import {newsletterRegionaut} from './Functions/newsletterRegionaut';
import {Gallery} from './Functions/Gallery';

domReady(() => {
  initMainNavigationHandler();
  initSearchHeader();
  initLanguageNav();
  initSlider();
  initSliderFilter();
  mailDecryption();
  initSliderFilterContent();
  quicklinkFilter();
  landingpageSwitch();
  newsletterFooter();
  initDocumentShop();
  initAlerts();
  initAccordionPrintHandler();
  initProjectButton();
  initPageTeaserSlider();
  initSwiperGallery();
  initBannerController();
  initSwiperTimeline();
  newsletterRegionaut();
  Gallery();
  new CalendarList();
  new MapDropdowns();
  (window as any).wiss_showHelp = wiss_showHelp;
  (window as any).wiss_hideHelp = wiss_hideHelp;
  (window as any).wiss_showMap = wiss_showMap;

  if (document.getElementsByClassName('js-electionTool').length) {
    import(/* webpackChunkName: "ElectionPresentation" */ './ElectionPresentationMain').then(module => {
      new module.ElectionPresentationMain();
    });
  }
});
